import TickerItem from './TickerItem';

export default TickerItem;